import Search from '@components/search'
import commerce from "@lib/api/commerce";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {getShopNavigation} from "../../index";

export async function getServerSideProps(context: any) {
  const {locale, params} = context;
  const config = { locale }
  const pagesPromise = commerce.getAllPages({ config, preview: false })
  const siteInfoPromise = commerce.getSiteInfo({ config, preview: false })
  const { pages } = await pagesPromise
  const { categories, brands } = await siteInfoPromise
  /*IMPORTANT: we encode the url here because its based on a brand name, if for example brand name is "100%" it
  * causes an error as the % sign is a special char in the url */
  brands.map(brand => {
    brand.node.path = encodeURI(brand.node.path)
  })
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "home"])),
      ...(await getShopNavigation(locale)), // makes "ShopNavigationColumn" property available on page props
      pages,
      categories,
      brands
    }
  }
}

export default Search
